import { useSwrImmutableNoAuth } from "../swr/useSwrImmutableNoAuth";


export const useFetchAuthCode = () => {
  const { data: authCode, error, isLoading } = useSwrImmutableNoAuth<string>('authentication/signup/auth-code/');
  return { authCode, isLoading, error };
};